module.exports = __webpack_public_path__ + "img/treasure-hunt-home.978ce257.jpg";